module.exports = __webpack_public_path__ + "img/calendar-icon.25288ea7.svg";